<template>
  <div class="comments-input-container">
    <textarea
      class="comments-input"
      placeholder="Anything else you would like to share?"
      @input="event => setAnswer(event.target.value)"
    ></textarea>
  </div>
</template>

<script>
import QuestionMixin from './QuestionMixin';

export default {
  name: 'comment',

  mixins: [QuestionMixin],
};
</script>

<style lang="scss" scoped>
.comments-input-container {
  margin: 15px 12.5%;
  width: 75%;
  height: 60vh;
  background-color: #effafa;
  border-radius: 12px 12px 12px 0px;
  padding: 20px;
  margin-top: -150px;
}

.comments-input {
  background: transparent;
  border: none;
  width: 100%;
  height: 100%;
  font-family: 'MyriadPro';
  font-size: 22px;
  color: #03aaa8;
}

.comments-input::-webkit-input-placeholder {
  color: #03aaa8;
}

.comments-input:focus {
  outline: none;
}
</style>
